var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatasources2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4b4848",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.25 4.125c0 1.03575-2.3505 1.875-5.25 1.875s-5.25-.83925-5.25-1.875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.25 7.125c0 1.03575-2.3505 1.875-5.25 1.875s-5.25-.83925-5.25-1.875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.25 10.125c0 1.0358-2.3505 1.875-5.25 1.875s-5.25-.8392-5.25-1.875v-6c0-1.03575 2.3505-1.875 5.25-1.875s5.25.83925 5.25 1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 12v1.875"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m10.125 15h4.875",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 15h4.875",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.7955 14.2045c.4393.4393.4393 1.1517 0 1.591-.43934.4393-1.15165.4393-1.591 0-.43933-.4393-.43933-1.1517 0-1.591.43934-.4393 1.15165-.4393 1.591 0z",
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasources2);
export default __webpack_public_path__ + "static/media/datasources-2.d2d64f27064d58a7da2304ad39346058.svg";
export { ForwardRef as ReactComponent };